import { StringUtils } from "@rsm-hcd/javascript-core";
import Breadcrumb from "atoms/breadcrumbs/breadcrumb";
import React, { useEffect } from "react";
import { match } from "react-router-dom";
import { useHeaderData } from "utilities/contexts/use-header-data-context";
import useCurrentNotebook from "utilities/hooks/domain/notebooks/use-current-notebook";

export interface NotebookBreadcrumbProps {
    match: match;
}
const NotebookPageBreadcrumb: React.FC<NotebookBreadcrumbProps> = (
    props: NotebookBreadcrumbProps
) => {
    const { match } = props;
    const { setPageTitle } = useHeaderData({ match });
    const { currentNotebook } = useCurrentNotebook();

    useEffect(() => {
        setPageTitle(currentNotebook?.name);
    }, [currentNotebook?.name, setPageTitle]);

    return (
        <Breadcrumb>
            <span className="c-breadcrumb__label">
                {`Notebooks - ${
                    StringUtils.hasValue(currentNotebook?.name)
                        ? currentNotebook?.name
                        : "..."
                }`}
            </span>
        </Breadcrumb>
    );
};

export default NotebookPageBreadcrumb;
